import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as actions from './actions';
import { semanticColors } from '../Globals/styles';
import Radium from 'radium';
import { Scrollbars } from 'react-custom-scrollbars';
import { addAlert } from '../MsgNotify/msgNotifyActions';
import SpreadsheetComponent from '../../Scripts/Spreadsheet/spreadsheet';
import NumberInput from '../Common/numberInput';
import SuggestSelectInput from '../Common/suggestSelectInput';

import Crew from './crew'

import auth from '../Login/authService'

class CustomPricelists extends Component {
    constructor(props) {
        super(props);
        props.dispatch(actions.getCustomPricelists())
        this.state = {
            v: {},
            data: {},
            search: '',
            showPasteInput: false,
            spreadSheetConfig: {
                rows: 2,
                columns: 7,
                headColumn: false,
                headColumnIsString: false,
                hasHeadRow: true,
                headRowIsString: true,
                canAddRow: true,
                canAddColumn: false,
                emptyValueSymbol: '',
                letterNumberHeads: false
            },
            defaultCellClasses: ['bold center', 'bold center', 'bold center', 'bold center', 'bold center', 'bold center', 'bold center'],
            cellClasses: {
                rows: [
                    ['bold center', 'bold center', 'bold center', 'bold center', 'bold center', 'bold center', 'bold center'],
                ]
            },
            pulseAnimation: Radium.keyframes({
                '0%': {
                    transform: "rotate(0deg) scaleX(1.00) scaleY(1.00)"
                },
                '10%': {
                    transform: "rotate(-3deg) scaleX(0.80) scaleY(0.80)"
                },
                '20%': {
                    transform: "rotate(-3deg) scaleX(0.80) scaleY(0.80)"
                },
                '30%': {
                    transform: "rotate(3deg) scaleX(1.20) scaleY(1.20)"
                },
                '40%': {
                    transform: "rotate(-3deg) scaleX(1.20) scaleY(1.20)"
                },
                '50%': {
                    transform: "rotate(3deg) scaleX(1.20) scaleY(1.20)"
                },
                '60%': {
                    transform: "rotate(-3deg) scaleX(1.20) scaleY(1.20)"
                },
                '70%': {
                    transform: "rotate(3deg) scaleX(1.20) scaleY(1.20)"
                },
                '80%': {
                    transform: "rotate(-3deg) scaleX(1.20) scaleY(1.20)"
                },
                '90%': {
                    transform: "rotate(3deg) scaleX(1.20) scaleY(1.20)"
                },
                '100%': {
                    transform: "rotate(0deg) scaleX(1.20) scaleY(1.20)"
                }
            }, 'pulse')
        }
    }

    componentWillMount() {
        if (auth.getProfile().role === 'Formand') {
            throw new Error('Formand forsøgte at tilgå prislister')
        }
    }

    componentWillReceiveProps = (nextProps) => {
        if (nextProps) {
            if (this.refs.spre) {

                if (this.props.offersKey !== nextProps.offersKey) {
                    this.refs.spre.setState({
                        data: {
                            rows: [
                                ['Pos.', 'Aktivitet', 'Enhed', 'Antal', 'Pris', 'Sum', 'Bemærkning'],
                                ...nextProps.offers
                            ]
                        }
                    })
                }
            }
        }
    }

    selectCustomPricelist = (id) => {
        const { dispatch } = this.props
        dispatch(actions.selectCustomPricelist(id))
    }
    createNew = () => {
        const { dispatch } = this.props
        dispatch(actions.createNew())
    }
    edit = () => {
        const { dispatch } = this.props
        dispatch(actions.edit())
    }
    createCopy = () => {
        const { dispatch } = this.props
        dispatch(actions.createCopy())
    }
    cancelCreate = () => {
        const { dispatch, mode } = this.props
        this.setState({
            showPasteInput: false
        })
        dispatch(actions.productDiscountsBeforeEdit())
        if (mode === 'create') {
            dispatch(actions.cancelCreate())

        } else {
            dispatch(actions.cancelCreateButton())

        }
    }
    deleteMode = () => {
        const { dispatch } = this.props
        dispatch(actions.deleteMode())
    }
    delete = () => {
        const { dispatch } = this.props
        dispatch(actions.deleteCustomPricelist())
    }
    validateOffers = (offers) => {
        const { dispatch } = this.props
        let arr = {}
        let result = true
        let errors = [
            this.state.defaultCellClasses,
        ]
        offers.forEach((o) => {
            const posNr = o[0]
            let errorArray = ["", "", "", "", "", "", ""]
            if (arr[posNr]) {
                result = false
                errorArray[0] = "error"
            }
            else {
                arr[posNr] = posNr
            }
            errors.push(errorArray)
        })
        this.setState({
            cellClasses: {
                rows: errors
            }
        })

        if (result === false) {
            dispatch({ type: 'BLINK' })
            dispatch(addAlert('Øvrige kan ikke have samme pos.'))
        }
        return result
    }
    submit = () => {
        const { dispatch, newName } = this.props
        if (newName) {
            const offers = this.refs.spre.state.data.rows.slice(1)
            if (this.validateOffers(offers)) {
                dispatch(actions.submit(offers))
                this.setState({
                    showPasteInput: false
                })
            }
        }
    }
    renderIcon = (text, icon, action, active, disabled, style) => {
        const { iconKey } = this.props
        return (
            <div
                key={iconKey + icon}
                className={disabled ? null : "waves-btn wavesHover"}
                style={[active ? styles.active : null, disabled ? styles.menuDisabled : null, style]}
                onClick={action}
            >
                <i
                    className={"fa " + icon}
                    aria-hidden="true"
                    style={styles.icon}
                ></i>
                <div style={styles.label}>
                    {text}
                </div>
            </div>
        )
    }
    renderMenuIcon(text, icon, action, active, disabled) {
        let style = null
        if (!disabled) {
            style = { cursor: 'pointer' }
        }
        return this.renderIcon(text, icon, action, active, disabled, [style, styles.iconsContainer])
    }

    renderSearchAndMenu() {
        const { selected } = this.props
        return (
            <div className="" style={{ paddingBottom: 20 }}>
                <div className="col-xs-4" style={{ paddingLeft: 20 }}>
                    <div className="input-group">
                        <span className="input-group-addon" style={{ backgroundColor: 'white' }}>
                            <i className="fa fa-search" aria-hidden="true">
                            </i>
                        </span>
                        <input
                            type="text"
                            style={styles.searchField}
                            placeholder="Søg"
                            onChange={(e) => {
                                this.setState({
                                    search: e.target.value
                                })
                            }} />
                    </div>
                </div>
                <div style={styles.iconsRow}>
                    {isNaN(selected) ?
                        this.renderMenuIcon("Slet", "fa-trash-o", () => { }, false, true)
                        :
                        this.renderMenuIcon("Slet", "fa-trash-o", this.deleteMode, false, false)}
                    <div style={styles.divider} />
                    {isNaN(selected) ?
                        this.renderMenuIcon("Rediger", "fa-pencil", () => { }, false, true)
                        :
                        this.renderMenuIcon("Rediger", "fa-pencil", this.edit, false, false)}
                    <div style={styles.divider} />
                    {isNaN(selected) ?
                        this.renderMenuIcon("Opret kopi", "fa-files-o", () => { }, false, true)
                        :
                        this.renderMenuIcon("Opret kopi", "fa-files-o", this.createCopy, false, false)}
                    <div style={styles.divider} />
                    {this.renderMenuIcon("Opret ny", "fa-file-o", this.createNew, false)}
                </div>
            </div>
        )
    }

    renderMenuForCreateMode = () => {
        const { mode } = this.props
        return (
            <div
                className=""
                style={{ paddingBottom: 50 }}
            >
                <div style={styles.iconsRow}>
                    {this.renderMenuIcon("Fortryd", "fa-undo", this.cancelCreate)}
                    <div style={styles.divider} />
                    {mode === 'create' ?
                        this.renderMenuIcon("Opret ny", "fa-file-o", () => { }, false, true)
                        :
                        this.renderMenuIcon("Rediger", "fa-pencil", () => { }, false, true)
                    }
                </div>
            </div>
        )
    }

    renderMenuForDeleteMode = () => {
        return (
            <div className=""
                style={{ paddingBottom: 20 }}
            >
                <div style={styles.iconsRow}>
                    {this.renderMenuIcon("Fortryd", "fa-undo", this.cancelCreate)}
                    <div style={styles.divider} />
                    {this.renderMenuIcon("Slet", "fa-trash-o", () => { }, false, true)}
                </div>
            </div>
        )
    }

    renderMenuForOffers = () => {
        const { dispatch, mode } = this.props
        return (
            <div
                className=""
                style={{ paddingBottom: 10 }}
            >
                <div style={styles.iconsRow}>
                    {this.renderMenuIcon("Ryd alt", "fa-trash", () => {
                        dispatch(actions.updateOffers([]))
                        if (mode === '' || mode === null || mode === undefined) {
                            this.edit()
                        }
                    }, false, false)
                    }
                    <div style={styles.divider} />
                    {this.state.showPasteInput === 'done' ?
                        this.renderMenuIcon("Importeret", "fa-check", () => this.setState({ showPasteInput: true }), true)
                        :
                        !this.state.showPasteInput ?
                            this.renderMenuIcon("Importer", "fa-clipboard", () => this.setState({ showPasteInput: true }))
                            :
                            <div style={{
                                float: 'right',
                                width: '115px',
                                paddingTop: 8,
                                paddingLeft: 5,
                                paddingRight: 5,
                                paddingBottom: 0,
                                height: '50px',

                            }}
                            >
                                <textarea
                                    defaultValue="Indsæt her"
                                    style={styles.excelInput}
                                    name="excel_data"
                                    onPaste={() => setTimeout(() => { this.generateTable() }, 0, 1)}
                                />
                                <i
                                    className={"fa fa-times-circle"}
                                    aria-hidden="true"
                                    style={{
                                        position: 'relative',
                                        bottom: '29px',
                                        right: '5px',
                                        cursor: 'pointer',
                                        float: 'right'
                                    }}
                                    onClick={() => this.setState({ showPasteInput: false })}
                                ></i>
                            </div>
                    }
                </div>
            </div>
        )
    }

    renderMenuForProductDiscounts = () => {
        const { suggestions, mode, dispatch } = this.props
        return (
            <div className="" style={{ paddingBottom: 10 }}>
                <div className="col-xs-4" style={{ paddingLeft: 20 }}>
                    <div className="input-group">
                        <span className="input-group-addon" style={{ backgroundColor: 'white' }}>
                            <i className="fa fa-search" aria-hidden="true">
                            </i>
                        </span>
                        <SuggestSelectInput
                            type="text"
                            onQuery={(q) => {
                                if (mode === '' || mode === null || mode === undefined) {
                                    this.edit()
                                }
                                dispatch(actions.getProductSuggestions(q))
                            }}
                            suggestions={suggestions}
                            placeholder="Tilføj fra katalog"
                            onChange={(val) => {
                                if (val.id !== null) {
                                    dispatch(actions.addProductToDiscountList(val))
                                    this.setState({ v: { id: null, name: '' } })
                                } else {
                                    this.setState({ v: { id: null, name: val.name } })
                                }
                            }}
                            value={this.state.v}
                            inputStyle={styles.searchField}
                        />
                    </div>
                </div>
            </div>
        )
    }


    renderCustomPriceList(index, checked, name, id, borders) {
        const c = checked ?
            <i
                className="fa fa-check-square-o"
                style={styles.check}
                aria-hidden="true"
            ></i>
            :
            <i
                className="fa fa-square-o"
                style={[styles.check, { paddingLeft: 2 }]}
                aria-hidden="true"
            ></i>
        return (
            <div
                key={id}
                className="col-xs-4"
                style={[styles.cursorPointer, borders ? styles.middlePricelist : null, { display: 'flex', alignItems: 'center' }]}
                onClick={() => this.selectCustomPricelist(index)}
            >
                {c}
                <div style={{ wordBreak: 'break-all' }}>
                    {name}
                </div>
            </div>
        )
    }

    splitSearch = () => {
        let filtered = []
        this.state.search.split(' ').forEach((w) => {
            if (w.length > 0) {
                filtered.push(w)
            }
        })
        return filtered
    }

    renderCustomPriceListRow = () => {
        const { customPricelists, selected } = this.props;

        let cps = customPricelists
        if (this.state.search.length > 1) {
            let searchWords = this.splitSearch();
            cps = customPricelists.filter((c) => {
                let passed = []
                for (var i = 0; i < searchWords.length; i++) {
                    if (c.name.toLowerCase().indexOf(searchWords[i].toLowerCase()) > -1) {
                        passed.push(true)
                    }
                }
                return passed.length === searchWords.length
            })
        }
        const cus = cps.map((cp, index) => {
            return (
                this.renderCustomPriceList(
                    index,
                    selected === index,
                    cp.name,
                    cp.customPricelistId,
                    ((index / 3 * 100) % 2).toFixed(2) === '1.33'
                )
            )
        })
        return (
            <Scrollbars style={{ height: '200px', width: '100%' }}
                renderTrackHorizontal={props => <div {...props} className="track-horizontal" style={{ display: "none" }} />}
                renderThumbHorizontal={props => <div {...props} className="thumb-horizontal" style={{ display: "none" }} />}
            >
                <div style={styles.pricelistRow}>
                    {cus}
                </div>
            </Scrollbars>
        )
    }

    renderCreateNameContainer = () => {
        const { createLoading, newName, dispatch } = this.props
        return (
            <div
                style={{ paddingTop: 50, height: 200 }}
                className=""
            >
                <div
                    className="col-xs-4"
                    style={{ textAlign: 'right', paddingTop: 5 }}
                >
                    Navn
            </div>
                <div
                    className="col-xs-4"
                >
                    <input type="text" value={newName} onChange={(e) => dispatch(actions.changeNewName(e.target.value))} />
                </div>
                <div
                    className="col-xs-4"
                    style={{ paddingLeft: 10 }}
                >
                    {createLoading ?
                        this.renderIcon('Gem', ' fa-spinner fa-spin', () => { }, true, false, styles.createModeIcon)
                        :
                        this.renderIcon('Gem', 'fa-save', this.submit, false, false, {
                            animation: 'linear 1s',
                            animationName: this.state.pulseAnimation,
                            transformOrigin: 'transform-origin: 50% 50%',
                            ...styles.createModeIcon
                        })}
                </div>

            </div>
        )
    }

    renderDeleteContainer = () => {
        const { customPricelists, selected, deleteLoading } = this.props
        return (
            <div
                style={{ paddingTop: 50, height: 200, textAlign: 'center' }}
            >
                <div
                >
                    Er du sikker på du vil slette
                </div>
                <div style={styles.active}>
                    {customPricelists[selected] ? customPricelists[selected].name : "null"}
                </div>
                <div>
                    ?
                </div>
                <div style={{ paddingTop: 5 }}>
                    {deleteLoading ?
                        this.renderIcon('Sletter', ' fa-spinner fa-spin', () => { }, true, false,)
                        :
                        this.renderIcon('Ja, slet', 'fa-trash-o', this.delete, false, false, { cursor: 'pointer' })}
                </div>
            </div>
        )
    }

    extend = () => {
        this.refs.spre.extendTable('down')
        if (this.props.mode === '' || this.props.mode === null || this.props.mode === undefined) {
            this.edit()
        }
    }

    generateTable = () => {
        const { dispatch, mode } = this.props

        var pasted = global.jQuery('textarea[name=excel_data]').val();
        const rows = pasted.split("\n");

        const parsedPasted = []
        for (var y in rows) {
            let cells = rows[y].split("\t");
            if (cells.length === 6) {
                let row = [];
                for (var x in cells) {
                    row.push(cells[x])
                }
                row[6] = ''
                parsedPasted.push(row);
            }
        }
        if (parsedPasted.length >= 1) {
            if (mode === '' || mode === null || mode === undefined) {
                this.edit()
            }
            dispatch(actions.pushOffers(parsedPasted))

            this.setState({
                showPasteInput: 'done',
            })
        }
    }

    renderSpreadSheet = () => {
        const { offers, offersKey } = this.props
        return (
            <div>
                <SpreadsheetComponent
                    ref="spre"
                    fu={() => {
                        if (this.props.mode !== 'create' && this.props.mode !== 'edit' && this.props.mode !== 'delete') {
                            this.edit()
                        }
                    }}
                    config={this.state.spreadSheetConfig}
                    spreadsheetId={offersKey ? offersKey : Math.random()}
                    key={offersKey ? offersKey : Math.random()}
                    initialData={{
                        rows:
                            [
                                ['Pos.', 'Aktivitet', 'Enhed', 'Antal', 'Pris', 'Sum', 'Bemærkning'],
                                ...offers
                            ]
                    }}
                    cellClasses={this.state.cellClasses}
                />
                <div className="" style={styles.addNewOfferRowContainer}>
                    <div className="col-xs-1 col-xs-offset-11">
                        <button
                            className="btn btn-info"
                            onClick={this.extend}>
                            Tilføj række
                        </button>
                    </div>
                </div>
            </div>
        )
    }

    renderProductDiscountsTable = () => {
        const { productDiscounts } = this.props
        return (
            <div>
                <table style={{ width: '100%', padding: 8 }}>
                    <tbody>
                        <tr style={{ backgroundColor: 'white' }}>
                            <th
                                className="col-xs-5"
                                style={[styles.thead, styles.borderRight]}>
                                Beskrivelse
                                </th>
                            <th
                                className="col-xs-1"
                                style={[styles.thead, styles.borderRight]}>
                                Enhed
                                </th>
                            <th
                                className="col-xs-1"
                                style={[styles.thead, styles.borderRight]}>
                                Type
                                </th>
                            <th
                                className="col-xs-2"
                                style={[styles.thead, styles.borderRight]}>
                                Standardpris
                                </th>
                            <th
                                className="col-xs-2"
                                style={[styles.thead, styles.borderRight]}>
                                Særpris
                                </th>
                            <th
                                className="col-xs-1"
                                style={[styles.thead]}>
                            </th>
                        </tr>
                        {productDiscounts.map((pd, index) => this.renderTr([pd.name, pd.unit, pd.type, pd.price, pd.discount], index))}
                    </tbody>
                </table>
                <div style={styles.addNewOfferRowContainer}></div>
            </div>
        )
    }

    renderCustomCrewRates = () => {
        return (
            <Crew
                crewKey={this.props.crewRatesKey}
                rows={this.props.crewRates}
                update={(fun, obj) => {
                    if (this.props.mode === '' || this.props.mode === null || this.props.mode === undefined) {
                        this.edit()
                    }
                    this.props.dispatch(actions.updateEmployeeFunction(fun, obj))
                }}
            />
        )
    }

    renderTd = (data, style, border) => {
        return (
            <td style={[{
                height: 35,
                paddingLeft: 10,
            }, style ? style : { textAlign: 'left' },
            border ? styles.borderRight : null, styles.borderTop]
            }>
                {data}
            </td >
        )
    }

    renderTdWithInput = (data, index) => {
        const { dispatch } = this.props
        return (
            <td style={{
                height: 35,
                textAlign: 'right',
                ...styles.borderRight,
                ...styles.borderTop,
            }} >
                <NumberInput
                    shouldNotCallOnChangeOnMount
                    style={{ textAlign: 'right', paddingRight: 10 }}
                    value={isNaN(data) ? 0 : data}
                    onChange={(val) => {
                        if (this.props.mode === '' || this.props.mode === null || this.props.mode === undefined) {
                            this.edit()
                        }
                        dispatch(actions.updateDiscount(index, val))
                    }}
                />
            </td >
        )
    }

    renderTr = (data, index) => {
        const { dispatch } = this.props
        return (
            <tr key={index}
                style={index % 2 === 0 ? { backgroundColor: '#EEF6F8' } : { backgroundColor: '#D6E9F0' }}>
                {this.renderTd(data[0], false, true)}
                {this.renderTd(data[1], { textAlign: 'center' }, true)}
                {this.renderTd(data[2], { textAlign: 'center' }, true)}
                {this.renderTd(data[3], { textAlign: 'right', paddingRight: 10 }, true)}
                {this.renderTdWithInput(data[4], index)}
                <td style={{
                    height: 35,
                    textAlign: 'center',
                }} >
                    <div
                        style={{ textAlign: 'center', cursor: 'pointer', ...styles.borderTop }}
                        onClick={() => dispatch(actions.removeDiscount(index))}
                    >
                        <i
                            className="fa fa-trash-o"
                            aria-hidden="true"
                        ></i>
                        <div>Slet</div>
                    </div>
                </td>

            </tr >
        )
    }

    renderLoadingBox = () => {
        return (
            <div style={{ height: '200px', width: '100%', textAlign: 'center', paddingTop: 65 }}>
                <i
                    className="fa fa-spinner fa-spin"
                    aria-hidden="true"
                    style={{ fontSize: 36 }}
                ></i>
            </div>
        )
    }

    render() {
        const { mode, loadingOffers, selected, loadingProductDiscounts, loadingCustomPricelists, loadingCrewRates } = this.props;
        return (
            <div style={styles.container}>
                <div style={{ height: '100%', width: '100%' }}>
                    <Scrollbars style={{ height: '100%', width: '100%' }}
                        renderTrackHorizontal={props => <div {...props} className="track-horizontal" style={{ display: "none" }} />}
                        renderThumbHorizontal={props => <div {...props} className="thumb-horizontal" style={{ display: "none" }} />}
                    >
                        {/* Særprislister */}
                        <div style={styles.topContainer}>
                            <div className="" style={styles.headerFont}>
                                Vælg prisliste
                    </div>
                            {mode === 'create' || mode === 'edit' ?
                                this.renderMenuForCreateMode() :
                                (mode === 'delete' ?
                                    this.renderMenuForDeleteMode() :
                                    this.renderSearchAndMenu())
                            }
                            {loadingCustomPricelists ? this.renderLoadingBox() :
                                mode === 'create' || mode === 'edit' ?
                                    this.renderCreateNameContainer() :
                                    (mode === 'delete' ?
                                        this.renderDeleteContainer()
                                        :
                                        this.renderCustomPriceListRow())

                            }

                        </div >
                        <div style={{ paddingBottom: 25 }}></div>

                        {/* Øvrige */}
                        {mode === 'create' || mode === 'edit' || !isNaN(selected) ?
                            <div style={styles.topContainer} id="exampleTwo">
                                <div className="" style={styles.headerFont}>
                                    Øvrige
                            </div>
                                {loadingOffers ? this.renderLoadingBox() :
                                    <div>
                                        {this.renderMenuForOffers()}
                                        {this.renderSpreadSheet()}
                                    </div>
                                }
                            </div>
                            : null}
                        <div style={{ paddingBottom: 25 }}></div>

                        {/* Særpriser */}
                        {mode === 'create' || mode === 'edit' || !isNaN(selected) ?
                            <div style={styles.topContainer}>
                                <div className="" style={styles.headerFont}>
                                    Særpriser for materielkatalog
                            </div>
                                {loadingProductDiscounts ? this.renderLoadingBox() :
                                    <div>
                                        {this.renderMenuForProductDiscounts()}
                                        {this.renderProductDiscountsTable()}
                                    </div>
                                }
                            </div>
                            : null}
                        <div style={{ paddingBottom: 25 }}></div>

                        {/* Mandskab */}
                        {mode === 'create' || mode === 'edit' || !isNaN(selected) ?
                            <div style={styles.topContainer}>
                                <div className="" style={styles.headerFont}>
                                    Særpriser for Mandskab
                            </div>
                                {loadingCrewRates ? this.renderLoadingBox() :
                                    <div style={{ padding: 8 }}>
                                        {this.renderCustomCrewRates()}
                                    </div>
                                }
                            </div>
                            : null}
                        <div style={{ paddingBottom: 100 }}></div>
                    </Scrollbars>
                </div >
            </div >
        );
    }
}

const styles = {
    headerFont: {
        color: semanticColors.mainBackground,
        textAlign: 'center',
        paddingTop: 5,
    },
    searchField: {
        boxShadow: 'none',
        borderRadius: 0,
        height: 36,
        minWidth: '200px',
        border: '1px solid #ccc',
    },
    topContainer: {
        height: 'auto',
        backgroundColor: semanticColors.default,
    },
    container: {
        position: 'absolute',
        paddingTop: '80px',
        top: 0,
        left: 0,
        height: '100%',
        width: '100%',
        '@media (min-width: 1200px)': {
            left: '50%',
            marginLeft: '-585px',
            maxWidth: '1170px'
        }
    },
    iconsContainer: {
        textAlign: 'center',
        float: 'right',
        width: '100px',
        height: '50px',
        padding: '5px'
    },
    iconsRow: {
        paddingRight: 20,
    },
    active: {
        color: 'rgb(90, 166, 194)',
    },
    menuDisabled: {
        color: 'grey'
    },
    label: {
        fontSize: '12px',
        marginTop: '4px',
        fontWeight: '600'
    },
    icon: {
        display: 'block',
        fontSize: '22px'
    },
    divider: {
        display: 'inline-block',
        float: 'right',
        width: '1px',
        height: '30px',
        marginTop: '10px',
        backgroundColor: semanticColors.mainBackground
    },
    createModeIcon: {
        textAlign: 'center',
        float: 'left',
        height: '50px',
        cursor: 'pointer',
    },
    check: {
        paddingTop: 4,
        paddingRight: '10px',
    },
    cursorPointer: {
        cursor: 'pointer',
        paddingTop: 5,
        paddingBottom: 5,
    },
    addNewOfferRowContainer: {
        paddingTop: 10,
        paddingRight: 50,
        height: '60px',
        backgroundColor: semanticColors.default,
    },
    pricelistContainer: {
        overflow: 'scroll',
        overflowX: 'hidden',
        overflowY: 'hidden',
        paddingTop: 25,
        lineHeight: '35px',
    },
    middlePricelist: {
        borderStyle: 'solid',
        borderColor: semanticColors.mainBackground,
        borderRightWidth: 1,
        borderLeftWidth: 1,
    },
    pricelistRow: {
        width: '99%',
        marginTop: 0,
        marginRight: 'auto',
        marginBottom: 0,
        marginLeft: 7,
        display: 'flex',
        flexWrap: 'wrap',
        paddingTop: 20,
    },
    elip: {
        height: '100%',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',       /* css-3 */
    },
    excelInput: {
        width: '100%',
        resize: 'none',
        height: '35px',
        paddingTop: '7px',
    },
    pDiscounts: {
        padding: 8,
        backgroundColor: '#F7F7F7',
        width: '100%'
    },
    thead: {
        textAlign: 'center',
        height: 35,
        fontWeight: '600',
    },
    borderRight: {
        borderRight: '1px solid #B7C9D2'
    },
    borderTop: {
        borderTop: '1px solid #B7C9D2'
    },
}

const selectProps = state => {
    return {
        ...state.customPricelistReducer
    };
}

export default connect(selectProps)(Radium(CustomPricelists));


// WEBPACK FOOTER //
// ./src/App/CustomPricelist/index.jsx